import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Explore } from './pages/Explore';
import { Services } from './pages/Services';
import { Heatmap } from './pages/Heatmap';
import { ScenicDetail } from './pages/ScenicDetail';
import { EventDetail } from './pages/EventDetail';
import { Toaster } from './components/Sonner';
export function App() {
  return <Router data-id="element-0">
      <div className="w-full min-h-screen font-sans antialiased text-[#333333]" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/explore" element={<Explore data-id="element-6" />} data-id="element-5" />
          <Route path="/service" element={<Services data-id="element-8" />} data-id="element-7" />
          <Route path="/heatmap" element={<Heatmap data-id="element-10" />} data-id="element-9" />
          <Route path="/scenic-detail/:id" element={<ScenicDetail data-id="element-12" />} data-id="element-11" />
          <Route path="/event-detail/:id" element={<EventDetail data-id="element-14" />} data-id="element-13" />
          <Route path="*" element={<Home data-id="element-16" />} data-id="element-15" />
        </Routes>
        <Toaster position="top-center" richColors data-id="element-17" />
      </div>
    </Router>;
}